import { render, staticRenderFns } from "./addTenderAnnouncement.vue?vue&type=template&id=40cd3a4e&scoped=true"
import script from "./addTenderAnnouncement.vue?vue&type=script&lang=js"
export * from "./addTenderAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./addTenderAnnouncement.vue?vue&type=style&index=0&id=40cd3a4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cd3a4e",
  null
  
)

export default component.exports